import Box from '@mui/material/Box';
import ModalElement from '@/views/elements/modal/ModalElement';

import classNames from 'classnames/bind';

import CloseIcon from '@mui/icons-material/Close';
import { Stack, useTheme } from '@mui/material';

import styles from '@/views/components/CopyTrade/Unauthorized/ModalRegisterMasterFollower.module.scss';
import React from 'react';
import TypographyElement from './typography/TypographyElement';
const cx = classNames.bind(styles);

export type PropsTypeWrapperModal = {
    children?: React.ReactNode
    open: boolean;
    handleClose: () => void;
    title: string;
    disableEscapeKeyDown?: boolean;
    hideBackdrop?: boolean;
    data?: any
    width?: number | string
    customHeader?: React.ReactNode
    triggerReload?: () => void
}

export default function WrapperModal({ children, open, handleClose, title, disableEscapeKeyDown = true, hideBackdrop = true, customHeader,
    width,
}: PropsTypeWrapperModal) {

    const theme = useTheme()

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: theme.palette.background.default,
        // border: '2px solid #000',
        p: '20px',
        borderRadius: 2
    };

    return (
        <ModalElement
            disableEscapeKeyDown={disableEscapeKeyDown}
            hideBackdrop={hideBackdrop}
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            styleBox={{ ...style, width: width ?? "98%", maxWidth: width ?? 500 }}
            sx={{
                backgroundColor: theme.palette.background.backdrop
            }}
        >
            <>
                <Stack
                    spacing={1}
                    direction={"row"}
                    alignItems={"center"}
                    justifyContent={"space-between"}
                    mb='20px'
                >
                    <Box>
                        <TypographyElement FontWeightElement={700} FontSizeElement='18px' id="modal-modal-title" variant="h5" component="h2" sx={{
                            lineHeight: '27px'
                        }}>
                            {title}
                        </TypographyElement>
                    </Box>
                    <CloseIcon onClick={handleClose} />
                </Stack>

                {customHeader && customHeader}

                <Box>
                    {children}
                </Box>
            </>
        </ModalElement >)
}